export default __webpack_public_path__ + "static/media/logo.997a89a1.png";